import { useVistaFeatureFlag } from '@99designs/experiments';

export function useDesignLiveMyDesignerFeatureFlag() {
    return useVistaFeatureFlag('design_services_design_live_my_designer', []);
}
